'use client'

import { useRouter } from 'next/navigation';

export default function RefereshButton() {
    const { refresh } = useRouter()

    return (
        <button onClick={() => refresh()} className='px-6 py-3.5 text-white bg-gray-600 border border-gray-600 rounded-2xl'>
            Try again
        </button>
    );
}